module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-index"
  }, [_c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": require("../../static/images/indexNq-share.jpg"),
      "height": "300",
      "width": "300"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "picSource"
  }, [_vm._v("图片来源:123RF正版图库")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.isTested == 0) ? _c('ul', {
    staticClass: "setSex"
  }, [_c('li', {
    staticClass: "setSex_male"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.answerSex('1')
      }
    }
  }, [_vm._v("男生入口")])]), _vm._v(" "), _c('li', {
    staticClass: "setSex_female"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.answerSex('2')
      }
    }
  }, [_vm._v("女生入口")])])]) : _vm._e(), _vm._v(" "), (_vm.isTested == 1) ? _c('ul', {
    staticClass: "testedMenu"
  }, [_c('li', {
    staticClass: "resetIstested",
    on: {
      "click": function($event) {
        _vm.redoDialog()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "checkReport",
    on: {
      "click": function($event) {
        _vm.checkReport()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('yxl-logo'), _vm._v(" "), (_vm.redoDialogShow) ? _c('div', {
    staticClass: "redoDialog"
  }, [_c('div', {
    staticClass: "redoMask"
  }, [_vm._v("!")]), _vm._v(" "), _c('div', {
    staticClass: "dialog"
  }, [_c('h1', [_vm._v("WARNING")]), _vm._v(" "), _c('p', [_vm._v("新的测试报告将会覆盖原来的测试结果，这可能会导致您重复付费，确定要再测一次吗？")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.redo()
      }
    }
  }, [_vm._v("再测一次")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.redoDialog()
      }
    }
  }, [_vm._v("容朕想想")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titles"
  }, [_c('div', {
    staticClass: "title_pic"
  }), _vm._v(" "), _c('div', {
    staticClass: "title_en"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-4aa4f8f9!./~/._vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Index.vue
// module id = 132
// module chunks = 2